/* eslint-disable no-restricted-imports */
import { formatPrice } from '@/utils/formatPrice';

/*
EJEMPLO:

Estos son los productos que quiero comprar:

  • {quantity} x {name}  (Código: {code} / Talla: {size}) - {price}

Total: $ 2069
*/

interface Product {
	code: string;
	name: string;
	price: number;
	size: string;
	quantity: number;
}

export const generateOrderWhatsAppMessage = (products: Product[]): string => {
	const total = products.reduce((acc, product) => acc + product.price * product.quantity, 0);
	const message = `Estos son los productos que quiero comprar:\n\n${products
		.map(
			(product) =>
				`• ${product.quantity} x ${product.name} (Código: ${product.code} ${
					product.size === 'U' ? '' : ` / Talla: ${product.size}`
				})${product.price > 0 ? ` - ${formatPrice('es-MX', 'MXN', product.price)}` : ''}\n`
		)
		.join('\n')}\n\n*Total*: ${formatPrice('es-MX', 'MXN', total)}`;

	return message;
};
